export default __webpack_public_path__ + "static/lavenderPoppy-917f4361ad8a77171a388a4aaabd8f3b.webp";